export const processName = `renderer process`
